import { render, staticRenderFns } from "./GAuthPassword.vue?vue&type=template&id=79aa583a&scoped=true&"
import script from "./GAuthPassword.vue?vue&type=script&lang=ts&"
export * from "./GAuthPassword.vue?vue&type=script&lang=ts&"
import style0 from "./GAuthPassword.vue?vue&type=style&index=0&id=79aa583a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aa583a",
  null
  
)

export default component.exports